import { HttpErrorResponse } from '@angular/common/http';
import { IUser, Patient } from '@app/modules/user/interface/user';
import { ModelAttributes } from '@app/core/interface/common';

export namespace UserActions {
  /**
   * @action ChangeSidebarVisible
   */
  export class ChangeSidebarVisible {
    static type = '[User] ChangeVisibility';
    constructor(public sidebarVisible: boolean) {}
  }


  /**
   * @action GetUser
   */
  export class GetUser {
    static type = '[User] GetUser';
  }
  export class GetUserSuccess {
    static type = '[User] GetUserSuccess';
  }
  export class GetUserFailed {
    static type = '[User] GetUserFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action CreateUser
   */
  export class CreateUser {
    static type = '[User] CreateUser';
    constructor(public user: IUser = {}) {}
  }
  export class CreateUserSuccess {
    static type = '[User] CreateUserSuccess';
  }
  export class CreateUserFailed {
    static type = '[User] CreateUserFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UpdateUser
   */
  export class UpdateUser {
    static type = '[User] UpdateUser';
    constructor(
      public user: IUser,
      public key: string,
      public isShowSnack: boolean = true
    ) {}
  }
  export class UpdateUserSuccess {
    static type = '[User] UpdateUserSuccess';
    constructor(public key: string, public isShowSnack: boolean = false) {}
  }
  export class UpdateUserFailed {
    static type = '[User] UpdateUserFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action UploadUserAvatar
   */
  export class UploadUserAvatar {
    static type = '[User] UploadUserAvatar';
    constructor(public value: FormData) {}
  }
  export class UploadUserAvatarSuccess {
    static type = '[User] UploadUserAvatarSuccess';
  }
  export class UploadUserAvatarFailed {
    static type = '[User] UploadUserAvatarFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action RemoveUserFromStorage
   */
  export class RemoveUserFromStorage {
    static type = '[User] RemoveUserFromStorage';
  }

  /**
   * @action GetUserFromStorage
   */
  export class GetUserFromStorage {
    static type = '[User] GetUserFromStorage';
  }

  /**
   * @action UpdateUserInStorage
   */
  export class UpdateUserInStorage {
    static type = '[User] UpdateUserInStorage';
    constructor(public user: IUser) {}
  }

  /**
   * @action Set active patient for proxy
   */
  export class SetActivePatient {
    static type = '[User] SetActivePatient';
    constructor(public patient: Patient) {}
  }

  /**
   * @action UpdatePatients
   * @action loadPatients
   */

  export class LoadPatients {
    static type = '[User] loadPatients';
  }

  export class UpdatePatients {
    static type = '[User] UpdatePatients';
  }
}
